function accordionContent() {
  var items = document.querySelectorAll('.accordion-item');
  if (!items[0]) {
    return;
  }
  items.forEach((item) => {
    var title = item.querySelector('.accordion-title');
    title.addEventListener('click', () => {
      item.classList.toggle('active');
    });
  });
}

function contentSearch() {
  var searchInput = document.querySelector('.accordion-content__input input');
  if (!searchInput) {
    return;
  }
  var items = document.querySelectorAll('.accordion-content__search p');

  searchInput.addEventListener('keyup', function () {
    debounce(searchItems(searchInput, items), 500);
  });

  function searchItems(input, items) {
    var filter = input.value.toLowerCase();
    items.forEach((item) => {
      var text = item.innerText.toLowerCase();
      if (text.indexOf(filter) > -1) {
        item.style.display = '';
      } else {
        item.style.display = 'none';
      }
    });
  }
}
function debounce(func, delay) {
  let timeoutId;

  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

document.addEventListener('DOMContentLoaded', () => {
  accordionContent();
  contentSearch();
});
